import React, { useEffect, useState } from "react";
import axios from "axios";
import { Gift, CircleCheck as CheckCircle2 } from "lucide-react";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const Rewards = () => {
  const [rewards, setRewards] = useState(null);

  useEffect(() => {
    axios.get(`${API}/portal/rewards`, { withCredentials: true }).then((res) => setRewards(res.data)).catch(() => {});
  }, []);

  if (!rewards) return null;

  const progressPct = Math.max(5, 100 - (rewards.points_to_next / (rewards.points + rewards.points_to_next)) * 100);

  return (
    <Reveal>
      <GlassCard accent="amber" className="p-8 max-w-2xl">
        <div className="flex items-center gap-4 mb-6">
          <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qamber/10 border border-qamber/25">
            <Gift size={26} className="text-qamber" />
          </span>
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide">Current Tier</p>
            <h3 className="font-display font-bold text-xl text-foreground">{rewards.tier}</h3>
          </div>
        </div>

        <div className="font-display font-bold text-4xl glow-text-amber mb-2">{rewards.points.toLocaleString()} pts</div>
        <div className="w-full h-2 rounded-full bg-white/5 overflow-hidden mb-2">
          <div className="h-full rounded-full bg-gradient-to-r from-qamber to-qamber-soft" style={{ width: `${progressPct}%` }} />
        </div>
        <p className="text-xs text-muted-foreground mb-8">{rewards.points_to_next} points to {rewards.next_tier}</p>

        <p className="text-xs text-muted-foreground uppercase tracking-wide mb-3">Your Perks</p>
        <ul className="space-y-2">
          {rewards.perks.map((perk) => (
            <li key={perk} className="flex items-center gap-2 text-sm text-muted-foreground">
              <CheckCircle2 size={16} className="text-qamber shrink-0" /> {perk}
            </li>
          ))}
        </ul>
      </GlassCard>
    </Reveal>
  );
};

export default Rewards;
